import { defineStore } from 'pinia';

export const useMobileStore = defineStore('mobile', () => {
  const showMenu = ref<boolean>(false);

  const toggleMenu = (): void => {
    showMenu.value = !showMenu.value;
  };

  return {
    showMenu,

    toggleMenu,
  };
});
